export const getTaskAssignmentLabel = (task) => {
  if (!task) return "-";
  if (task.assignedGroup) return task.assignedGroup;
  if (task.assignees?.length) {
    return task.assignees
      .map((assignee) => `${assignee.firstName} ${assignee.lastName}`)
      .join(", ");
  }
  return "-";
};

export const isTaskAssignedToGroup = (task) => !!task?.assignedGroup;

export const canClaimTask = (task, staffMember) => {
  if (
    !task ||
    !staffMember ||
    task.status === "Complete" ||
    task.status === "Cancelled"
  ) {
    return false;
  }

  if (task.assignedGroup) {
    return (
      task.assignedGroup.toLowerCase() ===
      (staffMember.mainRole || "").toLowerCase()
    );
  }

  return (
    (task.assignees?.length || 0) > 1 &&
    task.assignees.some(
      (assignee) => String(assignee.id) === String(staffMember.id)
    )
  );
};
